import "./App.css";
import About from "./components/About";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import React, { useState } from "react";
import Alert from "./components/Alert";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  const [mode, setMode] = useState("light"); //Whether dark mode is enabled or not

  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };

  const removeBodyClasses = () => {
    document.body.classList.remove('bg-light')
    document.body.classList.remove('bg-dark')
    document.body.classList.remove('bg-warning')
    document.body.classList.remove('bg-danger')
    document.body.classList.remove('bg-success')
    document.body.classList.remove('bg-primary')
  }


  const toggleMode = (cls) => {
    removeBodyClasses()
    // console.log(cls);
    document.body.classList.add('bg-' + cls)
    if (mode === "light") {
      setMode("dark");
      document.body.style.backgroundColor = "#4D4D4D";
      showAlert("Dark mode has been enabled", "success");
      // document.title = "Sun's TextUtils - Dark Mode"
      // setInterval(() => {
      //   document.title = "Sun's TextUtils is Awesome Mode"
      // }, 2000);
      // setInterval(() => {
      //   document.title = "Install Sun's TextUtils Now"
      // }, 1500);
    } else {
      setMode("light");
      document.body.style.backgroundColor = "white";
      showAlert("Light mode has been enabled", "success");
      // document.title = "Sun's TextUtils - Light Mode"
    }
  };
  return (
    <>
      <BrowserRouter>
        {/* <Navbar /> */}
        <Navbar title="Sun's TextUtils" mode={mode} toggleMode={toggleMode} />
        <Alert alert={alert} />
        <div className="container my-3">
          <Routes>
            {/* 
            exact path
            /users --> component 1
            /users/home --> component 2
             */}
            <Route
              exact path="/"
              element={
                <TextForm
                  showAlert={showAlert}
                  heading=" Try Sun's TextUtils - Word Counter, Character Counter, Remove extra spaces, Pronunce Text"
                  mode={mode}
                />
              }
            />
            <Route exact path="/about" element={<About mode={mode} />} />
          </Routes>
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
